const domainPattern = /^(?!-)[a-z0-9-]{1,63}(?<!-)(\.(?!-)[a-z0-9-]{1,63}(?<!-))+$/;

export const isValidDomain = (value: string): boolean => domainPattern.test(value.trim().toLowerCase());
